<template>
  <div class="text-label__container">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.text-label__container {
  width: fit-content;

  font-size: 36px;

  font-size: 36px;
  font-weight: 900;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: black;

  color: #9155fd;

  /* glow */
  /* color: #0ff;
  text-shadow: 0 0 10px #fff, 0 0 20px #fff, 0 0 30px #fff, 0 0 40px #0ff, 0 0 70px #0ff, 0 0 80px #0ff, 0 0 100px #0ff,
    0 0 150px #0ff; */
}
</style>

// text-shadow: 0 0 10px rgba(145, 85, 253, 0.3), /* Lighter, more transparent */ 0 0 20px rgba(145, 85, 253, 0.4), //
/* Slightly more opaque */ 0 0 30px rgba(145, 85, 253, 0.5), /* Mid-opacity */ 0 0 40px rgba(145, 85, 253, 0.6), // /*
Greater opacity */ 0 0 70px rgba(145, 85, 253, 0.7), /* More visible */ 0 0 80px rgba(145, 85, 253, 0.8), // /* Strong
presence */ 0 0 100px rgba(145, 85, 253, 0.9), /* Very strong presence */ 0 0 150px #9155fd; /* Fully opaque, the base
color */
